import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LoggerService, WhiteLabel } from '../shared/sdk';
import { WhiteLabelService } from '../shared/services/whitelabel.service';
import { WINDOW } from '../window.factory';

@Component({
  selector: 'app-public',
  templateUrl: './public.component.html',
  styleUrls: ['./public.component.css'],
})
export class PublicComponent implements OnInit, OnDestroy {
  isCollapsed = true;
  production = environment.production;
  WLprops$: Observable<WhiteLabel>;
  private onDestroy$: Subject<void> = new Subject();

  constructor(
    public WL: WhiteLabelService,
    private log: LoggerService,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(WINDOW) private window: Window,
  ) {}

  ngOnInit(): void {
    this.WLprops$ = this.WL.properties.pipe(
      takeUntil(this.onDestroy$),
      map((props: WhiteLabel) => {
        if (props) {
          const redirectUrl = props.unauthorizedRedirectURL || props.websiteURL;
          const {
            access_token: tokenParam,
            prevent_redirect: preventRedirect,
          } = this.route.snapshot.queryParams;

          if (
            props.hideLoginPage &&
            redirectUrl &&
            !tokenParam &&
            !preventRedirect
          ) {
            this.log.log(redirectUrl);
            this.window.open(redirectUrl, '_self');
          }

          if (this.router.url.indexOf('reset') !== -1 && props.hideLoginPage) {
            const resetUrl = props.passwordResetURL;

            if (resetUrl || redirectUrl) {
              this.window.open(resetUrl || redirectUrl, '_self');
            }
          }

          if (this.router.url.indexOf('signup') !== -1 && !props.showSignup) {
            const signupUrl = props.signupURL;

            if (signupUrl || redirectUrl) {
              this.window.open(signupUrl || redirectUrl, '_self');
            }
          }
        }

        return props;
      }),
    );
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
